import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { ensureDayjsLocales } from '../datepicker/helper/ensureDayjsLocales';
import { dateFormatter } from '../table/valueFormatters';

dayjs.extend(relativeTime);
ensureDayjsLocales();

const SEPARATOR = ' · ';

function firstLocale(locales: string | string[]): string | undefined {
  return Array.isArray(locales) ? locales[0] : locales;
}

function formatCreated(timestamp: number, locales: string | string[]): string {
  if (!Number.isFinite(timestamp)) {
    return '';
  }
  const formatted = dateFormatter(new Date(timestamp).toISOString(), {
    locales,
  });
  return typeof formatted === 'string' ? formatted : '';
}

function formatLastActive(
  timestamp: number,
  locales: string | string[]
): string {
  if (!Number.isFinite(timestamp)) {
    return '';
  }
  const locale = firstLocale(locales);
  // dayjs normalizes the tag ('en-GB' -> 'en-gb') and keeps the active locale
  // for tags with no registered pack.
  const date = locale ? dayjs(timestamp).locale(locale) : dayjs(timestamp);
  return date.fromNow();
}

/**
 * Chat-list second line: the creation date in the same format as page filters
 * and table cells, then how long ago the chat was last active. Returns the
 * finished line so the separator and the empty-part rule live in one place.
 */
export function formatChatListActivity(
  chat: { createdAt: number; updatedAt: number },
  locales: string | string[]
): string {
  return [
    formatCreated(chat.createdAt, locales),
    formatLastActive(chat.updatedAt, locales),
  ]
    .filter(Boolean)
    .join(SEPARATOR);
}
